import errors from './errors.js';
import translation from './translation/index.js';
const de = Object.freeze({
    translation,
    errors,
});
export default de;
